type DataTableSkeletonProps = {
  rows?: number;
  columns: number;
};

/**
 * DataTable loading 時に描画する skeleton 行。
 * @param {DataTableSkeletonProps} props rows (デフォルト 5) / columns
 * @return {JSX.Element} skeleton tbody
 */
export const DataTableSkeleton = ({
  rows = 5,
  columns,
}: DataTableSkeletonProps): JSX.Element => {
  return (
    <tbody>
      {Array.from({ length: rows }).map((_, rowIdx) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: skeleton rows are static
        <tr key={rowIdx} className="border-b border-base-200">
          {Array.from({ length: columns }).map((__, colIdx) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: skeleton cells are static
            <td key={colIdx} className="px-3 py-3">
              <div className="h-4 w-full bg-base-200 rounded animate-pulse" />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};
